interface BundlesIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const BundlesIcon = (props: BundlesIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  const style = {
    fill: 'none',
    stroke: fillColor,
    strokeWidth: 1,
    strokeLineCap: 'round',
    strokeLineJoin: 'round',
    strokeMiterLimit: 10,
  }

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path style={style} d="M33.6,16v-0.6c0-0.8-0.6-1.4-1.4-1.4H16.4c0,0-1.3-0.1-1.3,2s0,13.7,0,13.7" />
      <path style={style} d="M7.8,18.4H7c-0.8,0-1.4,0.6-1.4,1.4v10.8c0,1.4,1.2,2.6,2.6,2.6h24c0.8,0,1.4-0.6,1.4-1.4v0" />
      <path
        style={style}
        d="M13.4,27.9c-1.1,0.3-2.2-0.4-2.4-1.5L7.9,13.6c-0.3-1.1,0.4-2.2,1.5-2.4l5.5-1.3c1.1-0.3,2.2,0.4,2.4,1.5l0.2,1"
      />
      <path style={style} d="M13,8.8c0-1.1,0.9-2,2-2h10.1c1.1,0,2,0.9,2,2v3.4" />
      <path style={style} d="M29.1,8.1l2.7,0.6c1.1,0.2,1.7,1.3,1.5,2.4L33,12.4" />
      <line style={style} x1="9.8" y1="13.7" x2="15.8" y2="12.2" />
      <line style={style} x1="10.2" y1="15.7" x2="13.5" y2="14.8" />
      <line style={style} x1="24.9" y1="9.3" x2="18.4" y2="9.3" />
      <line style={style} x1="24.9" y1="11.4" x2="19.9" y2="11.4" />
      <line style={style} x1="27.3" y1="20.4" x2="27.3" y2="27.4" />
      <line style={style} x1="30.8" y1="23.9" x2="23.8" y2="23.9" />
      <circle style={style} cx="27.3" cy="23.9" r="7.1" />
    </svg>
  )
}

export default BundlesIcon
